{
  "langs": ["cs", "en"],
  "defaultLang": "cs",
  "translations": {
    "enum.all": ["Detailní", "Detailed"],
    "enum.arc": ["Oblouk", "Arc"],
    "enum.B": ["Dole", "Bottom"],
    "enum.basic": ["Základní", "Basic"],
    "enum.BL": ["Levý dolní roh", "Bottom left corner"],
    "enum.BR": ["Pravý dolní roh", "Bottom right corner"],
    "enum.central": ["Středová", "Central"],
    "enum.circle": ["Kruh", "Circle"],
    "enum.cut": ["Řez", "Cut"],
    "enum.CZK": ["CZK", "CZK"],
    "enum.email": ["E-mail", "E-mail"],
    "enum.EUR": ["EUR", "EUR"],
    "enum.merge": ["Sloučit", "Merge"],
    "enum.modeAdvanced": ["Pokročilé", "Advanced"],
    "enum.modeBasic": ["Základní", "Basic"],
    "enum.modeExpert": ["Expert", "Expert"],
    "enum.none": ["Žádná", "None"],
    "enum.nopass": ["Bez hesla", "No password"],
    "enum.phone": ["Telefon", "Phone"],
    "enum.raw": ["Text", "Raw text"],
    "enum.sided": ["Strany", "Sided"],
    "enum.solid": ["Plný", "Solid"],
    "enum.pay": ["Platba", "Payment"],
    "enum.bitcoin": ["Bitcoin", "Bitcoin"],
    "enum.split": ["Rozdělit", "Split"],
    "enum.square": ["Čtverec", "Square"],
    "enum.step": ["Schod", "Step"],
    "enum.T": ["Nahoře", "Top"],
    "enum.TL": ["Levý horní roh", "Top left corner"],
    "enum.TR": ["Pravý horní roh", "Top right corner"],
    "enum.uniform": ["Uniformní", "Uniform"],
    "enum.url": ["URL", "URL"],
    "enum.USD": ["USD", "USD"],
    "enum.vcard": ["Kontakt", "Contact"],
    "enum.WEP": ["WEP", "WEP"],
    "enum.wifi": ["Wi-Fi", "Wi-Fi"],
    "enum.WPA": ["WPA", "WPA"],
    "enum.zoned": ["Zóny", "Zoned"],
    "error.fallback": ["Použita výchozí hodnota", "Fallback applied"],
    "error.hidden": ["Skryté pole", "Hidden field"],
    "error.invalid": ["Neplatná hodnota", "Invalid value"],
    "error.max": ["Maximální hodnota", "Maximum value"],
    "error.min": ["Minimální hodnota", "Minimum value"],
    "error.normalized": ["Upraveno", "Normalized"],
    "error.protocol": ["Chybí protokol", "Missing protocol"],
    "error.required": ["Povinné pole", "Required field"],
    "field.amount.label": ["Částka", "Amount"],
    "field.bgClass.label": ["Třída pozadí", "Background class"],
    "field.bgCss.label": ["CSS pozadí", "Background CSS"],
    "field.bgFill.label": ["Výplň pozadí", "Background fill"],
    "field.bgFilter.label": ["Filtr pozadí", "Background filter"],
    "field.bgOn.label": ["Zobrazit pozadí", "Show background"],
    "field.bgOpacity.label": ["Průhlednost pozadí", "Background opacity"],
    "field.bgStroke.label": ["Obrys pozadí", "Background stroke"],
    "field.bgStrokeWidth.label": ["Šířka obrysu pozadí", "Background stroke width"],
    "field.bic.label": ["BIC", "BIC"],
    "field.label.label":[ "Štítek", "Label" ],
    "field.address.label":[ "Bitcoin peněženka", "Bitcoin wallet" ],
    "field.bitsClass.label": ["Třída bitů", "Bits class"],
    "field.bitsCorner.enum.all": ["Detailní", "Detailed"],
    "field.bitsCorner.enum.basic": ["Základní", "Basic"],
    "field.bitsCorner.enum.sided": ["Strany", "Sided"],
    "field.bitsCorner.enum.zoned": ["Zóny", "Zoned"],
    "field.bitsCorner.label": ["Režim rohů bitů", "Bits corner mode"],
    "field.bitsCornerBLRadius.label": ["Poloměr levého dolního rohu bitů", "Bits bottom-left corner radius"],
    "field.bitsCornerBLSteps.label": ["Kroky levého dolního rohu bitů", "Bits bottom-left corner steps"],
    "field.bitsCornerBLType.label": ["Typ levého dolního rohu bitů", "Bits bottom-left corner type"],
    "field.bitsCornerBRRadius.label": ["Poloměr pravého dolního rohu bitů", "Bits bottom-right corner radius"],
    "field.bitsCornerBRSteps.label": ["Kroky pravého dolního rohu bitů", "Bits bottom-right corner steps"],
    "field.bitsCornerBRType.label": ["Typ pravého dolního rohu bitů", "Bits bottom-right corner type"],
    "field.bitsCornerInnerBLRadius.label": ["Poloměr levého dolního vnitřního rohu bitů", "Bits bottom-left inner corner radius"],
    "field.bitsCornerInnerBLSteps.label": ["Kroky levého dolního vnitřního rohu bitů", "Bits bottom-left inner corner steps"],
    "field.bitsCornerInnerBLType.label": ["Typ levého dolního vnitřního rohu bitů", "Bits bottom-left inner corner type"],
    "field.bitsCornerInnerBRRadius.label": ["Poloměr pravého dolního vnitřního rohu bitů", "Bits bottom-right inner corner radius"],
    "field.bitsCornerInnerBRSteps.label": ["Kroky pravého dolního vnitřního rohu bitů", "Bits bottom-right inner corner steps"],
    "field.bitsCornerInnerBRType.label": ["Typ pravého dolního vnitřního rohu bitů", "Bits bottom-right inner corner type"],
    "field.bitsCornerInnerRadius.label": ["Poloměr vnitřního rohu bitů", "Bits inner corner radius"],
    "field.bitsCornerInnerSteps.label": ["Kroky vnitřního rohu bitů", "Bits inner corner steps"],
    "field.bitsCornerInnerTLRadius.label": ["Poloměr levého horního vnitřního rohu bitů", "Bits top-left inner corner radius"],
    "field.bitsCornerInnerTLSteps.label": ["Kroky levého horního vnitřního rohu bitů", "Bits top-left inner corner steps"],
    "field.bitsCornerInnerTLType.label": ["Typ levého horního vnitřního rohu bitů", "Bits top-left inner corner type"],
    "field.bitsCornerInnerTRRadius.label": ["Poloměr pravého horního vnitřního rohu bitů", "Bits top-right inner corner radius"],
    "field.bitsCornerInnerTRSteps.label": ["Kroky pravého horního vnitřního rohu bitů", "Bits top-right inner corner steps"],
    "field.bitsCornerInnerTRType.label": ["Typ pravého horního vnitřního rohu bitů", "Bits top-right inner corner type"],
    "field.bitsCornerInnerType.label": ["Typ vnitřního rohu bitů", "Bits inner corner type"],
    "field.bitsCornerOuterBLRadius.label": ["Poloměr levého dolního vnějšího rohu bitů", "Bits bottom-left outer corner radius"],
    "field.bitsCornerOuterBLSteps.label": ["Kroky levého dolního vnějšího rohu bitů", "Bits bottom-left outer corner steps"],
    "field.bitsCornerOuterBLType.label": ["Typ levého dolního vnějšího rohu bitů", "Bits bottom-left outer corner type"],
    "field.bitsCornerOuterBRRadius.label": ["Poloměr pravého dolního vnějšího rohu bitů", "Bits bottom-right outer corner radius"],
    "field.bitsCornerOuterBRSteps.label": ["Kroky pravého dolního vnějšího rohu bitů", "Bits bottom-right outer corner steps"],
    "field.bitsCornerOuterBRType.label": ["Typ pravého dolního vnějšího rohu bitů", "Bits bottom-right outer corner type"],
    "field.bitsCornerOuterRadius.label": ["Poloměr vnějšího rohu bitů", "Bits outer corner radius"],
    "field.bitsCornerOuterSteps.label": ["Kroky vnějšího rohu bitů", "Bits outer corner steps"],
    "field.bitsCornerOuterTLRadius.label": ["Poloměr levého horního vnějšího rohu bitů", "Bits top-left outer corner radius"],
    "field.bitsCornerOuterTLSteps.label": ["Kroky levého horního vnějšího rohu bitů", "Bits top-left outer corner steps"],
    "field.bitsCornerOuterTLType.label": ["Typ levého horního vnějšího rohu bitů", "Bits top-left outer corner type"],
    "field.bitsCornerOuterTRRadius.label": ["Poloměr pravého horního vnějšího rohu bitů", "Bits top-right outer corner radius"],
    "field.bitsCornerOuterTRSteps.label": ["Kroky pravého horního vnějšího rohu bitů", "Bits top-right outer corner steps"],
    "field.bitsCornerOuterTRType.label": ["Typ pravého horního vnějšího rohu bitů", "Bits top-right outer corner type"],
    "field.bitsCornerOuterType.label": ["Typ vnějšího rohu bitů", "Bits outer corner type"],
    "field.bitsCornerRadius.label": ["Poloměr rohů bitů", "Bits corner radius"],
    "field.bitsCornerSteps.label": ["Kroky rohů bitů", "Bits corner steps"],
    "field.bitsCornerTLRadius.label": ["Poloměr levého horního rohu bitů", "Bits top-left corner radius"],
    "field.bitsCornerTLSteps.label": ["Kroky levého horního rohu bitů", "Bits top-left corner steps"],
    "field.bitsCornerTLType.label": ["Typ levého horního rohu bitů", "Bits top-left corner type"],
    "field.bitsCornerTRRadius.label": ["Poloměr pravého horního rohu bitů", "Bits top-right corner radius"],
    "field.bitsCornerTRSteps.label": ["Kroky pravého horního rohu bitů", "Bits top-right corner steps"],
    "field.bitsCornerTRType.label": ["Typ pravého horního rohu bitů", "Bits top-right corner type"],
    "field.bitsCornerType.label": ["Typ rohů bitů", "Bits corner type"],
    "field.bitsCss.label": ["CSS bitů", "Bits CSS"],
    "field.bitsFill.label": ["Výplň bitů", "Bits fill"],
    "field.bitsFilter.label": ["Filtr bitů", "Bits filter"],
    "field.bitsForm.enum.merge": ["Sloučit", "Merge"],
    "field.bitsForm.enum.solid": ["Plný", "Solid"],
    "field.bitsForm.enum.split": ["Rozdělit", "Split"],
    "field.bitsForm.label": ["Tvar bitů", "Bits shape"],
    "field.bitsOpacity.label": ["Průhlednost bitů", "Bits opacity"],
    "field.bitsStroke.label": ["Obrys bitů", "Bits stroke"],
    "field.bitsStrokeWidth.label": ["Šířka obrysu bitů", "Bits stroke width"],
    "field.body.label": ["Zpráva", "Message"],
    "field.content.label": ["Obsah", "Content"],
    "field.contentType.enum.email": ["E-mail", "E-mail"],
    "field.contentType.enum.phone": ["Telefon", "Phone"],
    "field.contentType.enum.raw": ["Text", "Raw text"],
    "field.contentType.enum.pay": ["Platba", "Payment"],
    "field.contentType.enum.bitcoin": ["Bitcoin", "Bitcoin"],
    "field.contentType.enum.url": ["URL", "URL"],
    "field.contentType.enum.vcard": ["Kontakt", "Contact"],
    "field.contentType.enum.wifi": ["Wi-Fi", "Wi-Fi"],
    "field.contentType.label": ["Typ obsahu", "Content type"],
    "field.css.label": ["CSS", "CSS"],
    "field.currency.enum.CZK": ["CZK", "CZK"],
    "field.currency.enum.EUR": ["EUR", "EUR"],
    "field.currency.enum.USD": ["USD", "USD"],
    "field.currency.label": ["Měna", "Currency"],
    "field.defs.label": ["Defs", "Defs"],
    "field.dueDate.label": ["Datum splatnosti", "Due date"],
    "field.ecc.enum.L": ["L (25%)", "L (25%)"],
    "field.ecc.enum.M": ["M (30%)", "M (30%)"],
    "field.ecc.enum.Q": ["Q (35%)", "Q (35%)"],
    "field.ecc.enum.H": ["H (40%)", "H (40%)"],
    "field.ecc.label": ["Úroveň ECC", "ECC level"],
    "field.email.label": ["E-mail", "E-mail"],
    "field.encryption.enum.nopass": ["Bez hesla", "No password"],
    "field.encryption.enum.WEP": ["WEP", "WEP"],
    "field.encryption.enum.WPA": ["WPA", "WPA"],
    "field.encryption.label": ["Šifrování", "Encryption"],
    "field.eyesClass.label": ["Třída očí", "Eyes class"],
    "field.eyesCorner.enum.all": ["Detailní", "Detailed"],
    "field.eyesCorner.enum.basic": ["Základní", "Basic"],
    "field.eyesCorner.enum.sided": ["Strany", "Sided"],
    "field.eyesCorner.enum.zoned": ["Zóny", "Zoned"],
    "field.eyesCorner.label": ["Režim rohů očí", "Eyes corner mode"],
    "field.eyesCornerBLRadius.label": ["Poloměr levého dolního rohu očí", "Eyes bottom-left corner radius"],
    "field.eyesCornerBLSteps.label": ["Kroky levého dolního rohu očí", "Eyes bottom-left corner steps"],
    "field.eyesCornerBLType.label": ["Typ levého dolního rohu očí", "Eyes bottom-left corner type"],
    "field.eyesCornerBRRadius.label": ["Poloměr pravého dolního rohu očí", "Eyes bottom-right corner radius"],
    "field.eyesCornerBRSteps.label": ["Kroky pravého dolního rohu očí", "Eyes bottom-right corner steps"],
    "field.eyesCornerBRType.label": ["Typ pravého dolního rohu očí", "Eyes bottom-right corner type"],
    "field.eyesCornerInnerBLRadius.label": ["Poloměr levého dolního vnitřního rohu očí", "Eyes bottom-left inner corner radius"],
    "field.eyesCornerInnerBLSteps.label": ["Kroky levého dolního vnitřního rohu očí", "Eyes bottom-left inner corner steps"],
    "field.eyesCornerInnerBLType.label": ["Typ levého dolního vnitřního rohu očí", "Eyes bottom-left inner corner type"],
    "field.eyesCornerInnerBRRadius.label": ["Poloměr pravého dolního vnitřního rohu očí", "Eyes bottom-right inner corner radius"],
    "field.eyesCornerInnerBRSteps.label": ["Kroky pravého dolního vnitřního rohu očí", "Eyes bottom-right inner corner steps"],
    "field.eyesCornerInnerBRType.label": ["Typ pravého dolního vnitřního rohu očí", "Eyes bottom-right inner corner type"],
    "field.eyesCornerInnerRadius.label": ["Poloměr vnitřního rohu očí", "Eyes inner corner radius"],
    "field.eyesCornerInnerSteps.label": ["Kroky vnitřního rohu očí", "Eyes inner corner steps"],
    "field.eyesCornerInnerTLRadius.label": ["Poloměr levého horního vnitřního rohu očí", "Eyes top-left inner corner radius"],
    "field.eyesCornerInnerTLSteps.label": ["Kroky levého horního vnitřního rohu očí", "Eyes top-left inner corner steps"],
    "field.eyesCornerInnerTLType.label": ["Typ levého horního vnitřního rohu očí", "Eyes top-left inner corner type"],
    "field.eyesCornerInnerTRRadius.label": ["Poloměr pravého horního vnitřního rohu očí", "Eyes top-right inner corner radius"],
    "field.eyesCornerInnerTRSteps.label": ["Kroky pravého horního vnitřního rohu očí", "Eyes top-right inner corner steps"],
    "field.eyesCornerInnerTRType.label": ["Typ pravého horního vnitřního rohu očí", "Eyes top-right inner corner type"],
    "field.eyesCornerInnerType.label": ["Typ vnitřního rohu očí", "Eyes inner corner type"],
    "field.eyesCornerOuterBLRadius.label": ["Poloměr levého dolního vnějšího rohu očí", "Eyes bottom-left outer corner radius"],
    "field.eyesCornerOuterBLSteps.label": ["Kroky levého dolního vnějšího rohu očí", "Eyes bottom-left outer corner steps"],
    "field.eyesCornerOuterBLType.label": ["Typ levého dolního vnějšího rohu očí", "Eyes bottom-left outer corner type"],
    "field.eyesCornerOuterBRRadius.label": ["Poloměr pravého dolního vnějšího rohu očí", "Eyes bottom-right outer corner radius"],
    "field.eyesCornerOuterBRSteps.label": ["Kroky pravého dolního vnějšího rohu očí", "Eyes bottom-right outer corner steps"],
    "field.eyesCornerOuterBRType.label": ["Typ pravého dolního vnějšího rohu očí", "Eyes bottom-right outer corner type"],
    "field.eyesCornerOuterRadius.label": ["Poloměr vnějšího rohu očí", "Eyes outer corner radius"],
    "field.eyesCornerOuterSteps.label": ["Kroky vnějšího rohu očí", "Eyes outer corner steps"],
    "field.eyesCornerOuterTLRadius.label": ["Poloměr levého horního vnějšího rohu očí", "Eyes top-left outer corner radius"],
    "field.eyesCornerOuterTLSteps.label": ["Kroky levého horního vnějšího rohu očí", "Eyes top-left outer corner steps"],
    "field.eyesCornerOuterTLType.label": ["Typ levého horního vnějšího rohu očí", "Eyes top-left outer corner type"],
    "field.eyesCornerOuterTRRadius.label": ["Poloměr pravého horního vnějšího rohu očí", "Eyes top-right outer corner radius"],
    "field.eyesCornerOuterTRSteps.label": ["Kroky pravého horního vnějšího rohu očí", "Eyes top-right outer corner steps"],
    "field.eyesCornerOuterTRType.label": ["Typ pravého horního vnějšího rohu očí", "Eyes top-right outer corner type"],
    "field.eyesCornerOuterType.label": ["Typ vnějšího rohu očí", "Eyes outer corner type"],
    "field.eyesCornerRadius.label": ["Poloměr rohů očí", "Eyes corner radius"],
    "field.eyesCornerSteps.label": ["Kroky rohů očí", "Eyes corner steps"],
    "field.eyesCornerTLRadius.label": ["Poloměr levého horního rohu očí", "Eyes top-left corner radius"],
    "field.eyesCornerTLSteps.label": ["Kroky levého horního rohu očí", "Eyes top-left corner steps"],
    "field.eyesCornerTLType.label": ["Typ levého horního rohu očí", "Eyes top-left corner type"],
    "field.eyesCornerTRRadius.label": ["Poloměr pravého horního rohu očí", "Eyes top-right corner radius"],
    "field.eyesCornerTRSteps.label": ["Kroky pravého horního rohu očí", "Eyes top-right corner steps"],
    "field.eyesCornerTRType.label": ["Typ pravého horního rohu očí", "Eyes top-right corner type"],
    "field.eyesCornerType.label": ["Typ rohů očí", "Eyes corner type"],
    "field.eyesCss.label": ["CSS očí", "Eyes CSS"],
    "field.eyesFill.label": ["Výplň očí", "Eyes fill"],
    "field.eyesFilter.label": ["Filtr očí", "Eyes filter"],
    "field.eyesForm.enum.merge": ["Sloučit", "Merge"],
    "field.eyesForm.enum.solid": ["Plný", "Solid"],
    "field.eyesForm.enum.split": ["Rozdělit", "Split"],
    "field.eyesForm.label": ["Tvar očí", "Eyes shape"],
    "field.eyesOn.label": ["Zobrazit oči", "Show eyes"],
    "field.eyesOpacity.label": ["Průhlednost očí", "Eyes opacity"],
    "field.eyesStroke.label": ["Obrys očí", "Eyes stroke"],
    "field.eyesStrokeWidth.label": ["Šířka obrysu očí", "Eyes stroke width"],
    "field.firstName.label": ["Jméno", "First name"],
    "field.hidden.label": ["Skrytá síť", "Hidden network"],
    "field.iban.label": ["IBAN", "IBAN"],
    "field.id.label": ["ID", "ID"],
    "field.ks.label": ["Konstantní symbol", "Constant symbol"],
    "field.lastName.label": ["Příjmení", "Last name"],
    "field.lblClass.label": ["Třída popisku", "Label class"],
    "field.lblCss.label": ["CSS popisku", "Label CSS"],
    "field.lblFill.label": ["Výplň popisku", "Label fill"],
    "field.lblFilter.label": ["Filtr popisku", "Label filter"],
    "field.lblGap.label": ["Odstup popisku", "Label gap"],
    "field.lblOpacity.label": ["Průhlednost popisku", "Label opacity"],
    "field.lblPos.enum.B": ["Dole", "Bottom"],
    "field.lblPos.enum.BL": ["Levý dolní roh", "Bottom left corner"],
    "field.lblPos.enum.BR": ["Pravý dolní roh", "Bottom right corner"],
    "field.lblPos.enum.none": ["Žádná", "None"],
    "field.lblPos.enum.T": ["Nahoře", "Top"],
    "field.lblPos.enum.TL": ["Levý horní roh", "Top left corner"],
    "field.lblPos.enum.TR": ["Pravý horní roh", "Top right corner"],
    "field.lblPos.label": ["Pozice popisku", "Label position"],
    "field.lblScale.label": ["Velikost popisku", "Label size"],
    "field.lblStroke.label": ["Obrys popisku", "Label stroke"],
    "field.lblStrokeWidth.label": ["Šířka obrysu popisku", "Label stroke width"],
    "field.lblValue.label": ["Hodnota popisku", "Label value"],
    "field.message.label": ["Zpráva", "Message"],
    "field.midClass.label": ["Třída středu", "Center class"],
    "field.midCss.label": ["CSS středu", "Center CSS"],
    "field.midFill.label": ["Výplň středu", "Center fill"],
    "field.midFilter.label": ["Filtr středu", "Center filter"],
    "field.midImg.label": ["Obrázek středu", "Center image"],
    "field.midImgInject.label": ["Zkusit SVG injektáž", "Try SVG injection"],
    "field.midSvgId.label": ["ID SVG injekce", "ID SVG injection"],
    "field.midImgSize.label": ["Velikost obrázku středu", "Center image size"],
    "field.midImgX.label": ["Posun obrázku X", "Center image offset X"],
    "field.midImgY.label": ["Posun obrázku Y", "Center image offset Y"],
    "field.midMaskSize.label": ["Velikost masky středu", "Center mask size"],
    "field.midMaskType.enum.circle": ["Kruh", "Circle"],
    "field.midMaskType.enum.none": ["Žádná", "None"],
    "field.midMaskType.enum.square": ["Čtverec", "Square"],
    "field.midMaskType.label": ["Typ masky středu", "Center mask type"],
    "field.midOpacity.label": ["Průhlednost středu", "Center opacity"],
    "field.midStroke.label": ["Obrys středu", "Center stroke"],
    "field.midStrokeWidth.label": ["Šířka obrysu středu", "Center stroke width"],
    "field.mode.enum.modeAdvanced": ["Pokročilé", "Advanced"],
    "field.mode.enum.modeBasic": ["Základní", "Basic"],
    "field.mode.enum.modeExpert": ["Expert", "Expert"],
    "field.mode.label": ["Režim", "Mode"],
    "field.name.label": ["Jméno", "Name"],
    "field.note.label": ["Poznámka", "Note"],
    "field.org.label": ["Firma", "Organization"],
    "field.padding.label": ["Odsazení", "Padding"],
    "field.password.label": ["Heslo", "Password"],
    "field.phone.label": ["Telefon", "Phone"],
    "field.pupilsClass.label": ["Třída zorniček", "Pupils class"],
    "field.pupilsCorner.enum.all": ["Detailní", "Detailed"],
    "field.pupilsCorner.enum.basic": ["Základní", "Basic"],
    "field.pupilsCorner.enum.sided": ["Strany", "Sided"],
    "field.pupilsCorner.enum.zoned": ["Zóny", "Zoned"],
    "field.pupilsCorner.label": ["Režim rohů zorniček", "Pupils corner mode"],
    "field.pupilsCornerBLRadius.label": ["Poloměr levého dolního rohu zorniček", "Pupils bottom-left corner radius"],
    "field.pupilsCornerBLSteps.label": ["Kroky levého dolního rohu zorniček", "Pupils bottom-left corner steps"],
    "field.pupilsCornerBLType.label": ["Typ levého dolního rohu zorniček", "Pupils bottom-left corner type"],
    "field.pupilsCornerBRRadius.label": ["Poloměr pravého dolního rohu zorniček", "Pupils bottom-right corner radius"],
    "field.pupilsCornerBRSteps.label": ["Kroky pravého dolního rohu zorniček", "Pupils bottom-right corner steps"],
    "field.pupilsCornerBRType.label": ["Typ pravého dolního rohu zorniček", "Pupils bottom-right corner type"],
    "field.pupilsCornerInnerBLRadius.label": ["Poloměr levého dolního vnitřního rohu zorniček", "Pupils bottom-left inner corner radius"],
    "field.pupilsCornerInnerBLSteps.label": ["Kroky levého dolního vnitřního rohu zorniček", "Pupils bottom-left inner corner steps"],
    "field.pupilsCornerInnerBLType.label": ["Typ levého dolního vnitřního rohu zorniček", "Pupils bottom-left inner corner type"],
    "field.pupilsCornerInnerBRRadius.label": ["Poloměr pravého dolního vnitřního rohu zorniček", "Pupils bottom-right inner corner radius"],
    "field.pupilsCornerInnerBRSteps.label": ["Kroky pravého dolního vnitřního rohu zorniček", "Pupils bottom-right inner corner steps"],
    "field.pupilsCornerInnerBRType.label": ["Typ pravého dolního vnitřního rohu zorniček", "Pupils bottom-right inner corner type"],
    "field.pupilsCornerInnerRadius.label": ["Poloměr vnitřního rohu zorniček", "Pupils inner corner radius"],
    "field.pupilsCornerInnerSteps.label": ["Kroky vnitřního rohu zorniček", "Pupils inner corner steps"],
    "field.pupilsCornerInnerTLRadius.label": ["Poloměr levého horního vnitřního rohu zorniček", "Pupils top-left inner corner radius"],
    "field.pupilsCornerInnerTLSteps.label": ["Kroky levého horního vnitřního rohu zorniček", "Pupils top-left inner corner steps"],
    "field.pupilsCornerInnerTLType.label": ["Typ levého horního vnitřního rohu zorniček", "Pupils top-left inner corner type"],
    "field.pupilsCornerInnerTRRadius.label": ["Poloměr pravého horního vnitřního rohu zorniček", "Pupils top-right inner corner radius"],
    "field.pupilsCornerInnerTRSteps.label": ["Kroky pravého horního vnitřního rohu zorniček", "Pupils top-right inner corner steps"],
    "field.pupilsCornerInnerTRType.label": ["Typ pravého horního vnitřního rohu zorniček", "Pupils top-right inner corner type"],
    "field.pupilsCornerInnerType.label": ["Typ vnitřního rohu zorniček", "Pupils inner corner type"],
    "field.pupilsCornerOuterBLRadius.label": ["Poloměr levého dolního vnějšího rohu zorniček", "Pupils bottom-left outer corner radius"],
    "field.pupilsCornerOuterBLSteps.label": ["Kroky levého dolního vnějšího rohu zorniček", "Pupils bottom-left outer corner steps"],
    "field.pupilsCornerOuterBLType.label": ["Typ levého dolního vnějšího rohu zorniček", "Pupils bottom-left outer corner type"],
    "field.pupilsCornerOuterBRRadius.label": ["Poloměr pravého dolního vnějšího rohu zorniček", "Pupils bottom-right outer corner radius"],
    "field.pupilsCornerOuterBRSteps.label": ["Kroky pravého dolního vnějšího rohu zorniček", "Pupils bottom-right outer corner steps"],
    "field.pupilsCornerOuterBRType.label": ["Typ pravého dolního vnějšího rohu zorniček", "Pupils bottom-right outer corner type"],
    "field.pupilsCornerOuterRadius.label": ["Poloměr vnějšího rohu zorniček", "Pupils outer corner radius"],
    "field.pupilsCornerOuterSteps.label": ["Kroky vnějšího rohu zorniček", "Pupils outer corner steps"],
    "field.pupilsCornerOuterTLRadius.label": ["Poloměr levého horního vnějšího rohu zorniček", "Pupils top-left outer corner radius"],
    "field.pupilsCornerOuterTLSteps.label": ["Kroky levého horního vnějšího rohu zorniček", "Pupils top-left outer corner steps"],
    "field.pupilsCornerOuterTLType.label": ["Typ levého horního vnějšího rohu zorniček", "Pupils top-left outer corner type"],
    "field.pupilsCornerOuterTRRadius.label": ["Poloměr pravého horního vnějšího rohu zorniček", "Pupils top-right outer corner radius"],
    "field.pupilsCornerOuterTRSteps.label": ["Kroky pravého horního vnějšího rohu zorniček", "Pupils top-right outer corner steps"],
    "field.pupilsCornerOuterTRType.label": ["Typ pravého horního vnějšího rohu zorniček", "Pupils top-right outer corner type"],
    "field.pupilsCornerOuterType.label": ["Typ vnějšího rohu zorniček", "Pupils outer corner type"],
    "field.pupilsCornerRadius.label": ["Poloměr rohů zorniček", "Pupils corner radius"],
    "field.pupilsCornerSteps.label": ["Kroky rohů zorniček", "Pupils corner steps"],
    "field.pupilsCornerTLRadius.label": ["Poloměr levého horního rohu zorniček", "Pupils top-left corner radius"],
    "field.pupilsCornerTLSteps.label": ["Kroky levého horního rohu zorniček", "Pupils top-left corner steps"],
    "field.pupilsCornerTLType.label": ["Typ levého horního rohu zorniček", "Pupils top-left corner type"],
    "field.pupilsCornerTRRadius.label": ["Poloměr pravého horního rohu zorniček", "Pupils top-right corner radius"],
    "field.pupilsCornerTRSteps.label": ["Kroky pravého horního rohu zorniček", "Pupils top-right corner steps"],
    "field.pupilsCornerTRType.label": ["Typ pravého horního rohu zorniček", "Pupils top-right corner type"],
    "field.pupilsCornerType.label": ["Typ rohů zorniček", "Pupils corner type"],
    "field.pupilsCss.label": ["CSS zorniček", "Pupils CSS"],
    "field.pupilsFill.label": ["Výplň zorniček", "Pupils fill"],
    "field.pupilsFilter.label": ["Filtr zorniček", "Pupils filter"],
    "field.pupilsForm.enum.merge": ["Sloučit", "Merge"],
    "field.pupilsForm.enum.solid": ["Plný", "Solid"],
    "field.pupilsForm.enum.split": ["Rozdělit", "Split"],
    "field.pupilsForm.label": ["Tvar zorniček", "Pupils shape"],
    "field.pupilsOn.label": ["Zobrazit zorničky", "Show pupils"],
    "field.pupilsOpacity.label": ["Průhlednost zorniček", "Pupils opacity"],
    "field.pupilsStroke.label": ["Obrys zorniček", "Pupils stroke"],
    "field.pupilsStrokeWidth.label": ["Šířka obrysu zorniček", "Pupils stroke width"],
    "field.rotation.label": ["Rotace", "Rotation"],
    "field.size.label": ["Velikost (px)", "Size (px)"],
    "field.ss.label": ["Specifický symbol", "Specific symbol"],
    "field.ssid.label": ["SSID", "SSID"],
    "field.subject.label": ["Předmět", "Subject"],
    "field.symmetry.enum.central": ["Středová", "Central"],
    "field.symmetry.enum.uniform": ["Uniformní", "Uniform"],
    "field.symmetry.label": ["Symetrie", "Symmetry"],
    "field.title.label": ["Pozice", "Title"],
    "field.url.label": ["URL", "URL"],
    "field.vs.label": ["Variabilní symbol", "Variable symbol"],
    "group.bg.label": ["Pozadí", "Background"],
    "group.bits.label": ["Bity", "Bits"],
    "group.config.label": ["Nastavení", "Settings"],
    "group.contact.label": ["Kontakt", "Contact"],
    "group.extra.label": ["Extra", "Extra"],
    "group.eyes.label": ["Oči", "Eyes"],
    "group.lbl.label": ["Popisek", "Label"],
    "group.main.label": ["Hlavní", "Main"],
    "group.mid.label": ["Střed", "Center"],
    "group.pupils.label": ["Zorničky", "Pupils"],
    "group.recipient.label": ["Příjemce", "Recipient"],
    "group.symbols.label": ["Symboly", "Symbols"],
    "issue.allowed": ["Povoleno", "Allowed"],
    "label.config": ["Nastavení", "Settings"],
    "label.downloadPng": ["Stáhnout PNG", "Download PNG"],
    "label.downloadSvg": ["Stáhnout SVG", "Download SVG"],
    "label.input": ["Obsah", "Content"],
    "label.preview": ["Náhled", "Preview"],
    "label.styles": ["Styl", "Style"],
    "lang.cs": ["Čeština", "Czech"],
    "lang.en": ["English", "English"]
  }
}
